import { render, staticRenderFns } from "./WorkflowSettings.vue?vue&type=template&id=15ce906c&scoped=true&"
import script from "./WorkflowSettings.vue?vue&type=script&lang=ts&"
export * from "./WorkflowSettings.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowSettings.vue?vue&type=style&index=0&id=15ce906c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce906c",
  null
  
)

export default component.exports